
















































































































































import Proxyable from '@/mixins/proxyable';
import { FormFieldTypeEnum, IFormFieldData, IFormSectionData } from '@/models';
import mixins from '@/utils/mixins';
import { PropType } from 'vue';
import { PropertyTabs } from '../FormBuilderPropertiesDrawer.vue';

export default mixins(Proxyable).extend({
  name: 'FormBuilderGeneralTab',

  props: {
    value: Object as PropType<IFormSectionData>,
    selectedFieldIndex: Number
  },

  data() {
    return {
      FormFieldTypeEnum,
      PropertyTabs,

      widthOptions: [
        { display_name: 'Quarter width', value: 3 },
        { display_name: 'Half width', value: 6 },
        { display_name: 'Full width', value: 12 }
      ],

      fieldTypes: [
        {
          icon: 'mdi-format-text',
          text: 'Label',
          value: FormFieldTypeEnum.Label
        },
        {
          icon: 'mdi-form-textbox',
          text: 'Short input box',
          value: FormFieldTypeEnum.Textfield
        },
        {
          icon: 'mdi-text-recognition',
          text: 'Long input box',
          value: FormFieldTypeEnum.Textarea
        },
        {
          icon: 'mdi-form-dropdown',
          text: 'Dropdown',
          value: FormFieldTypeEnum.Combobox
        },
        {
          icon: 'mdi-calendar-range',
          text: 'Date',
          value: FormFieldTypeEnum.DatePicker
        },
        {
          icon: 'mdi-order-bool-ascending-variant',
          text: 'Checklist',
          value: FormFieldTypeEnum.Checkbox
        },
        {
          icon: 'mdi-radiobox-marked',
          text: 'Radio Button',
          value: FormFieldTypeEnum.Radiobutton
        },
        {
          icon: 'mdi-paperclip',
          text: 'File',
          value: FormFieldTypeEnum.FileField
        }
      ]
    };
  },

  computed: {
    canAddOptionsAndTodos(): boolean {
      let canAdd = false;

      const FieldOptionTypesList = [
        FormFieldTypeEnum.Checkbox,
        FormFieldTypeEnum.Radiobutton,
        FormFieldTypeEnum.Combobox
      ];

      canAdd = FieldOptionTypesList.includes(
        (this.internalValue.section_fields[this.selectedFieldIndex]
          .field_template as IFormFieldData).type
      );

      return canAdd;
    },

    fieldDisplayType(): string {
      return this.fieldTypes.find(
        type =>
          type.value ==
          this.internalValue.section_fields[this.selectedFieldIndex]
            .field_template.type
      )!.text;
    }
  },

  methods: {
    goToTabWindow(tab: PropertyTabs) {
      this.$emit('goToTabWindow', tab);
    },

    save() {
      this.$emit('save');
    },

    close() {
      this.$emit('close');
    }
  }
});
